<template>
  <div>
    <div id="dashboard-analytics">
      <div class="vx-row">

        <!-- CARD 1: CONGRATS -->
        <div class="w-full lg:w-full mb-base justify-center">
          <vx-card slot="no-body" class="text-center bg-primary-gradient greet-user">
            <img src="@/assets/images/elements/decore-left.png" class="decore-left" alt="Decore Left" width="200" >
            <img src="@/assets/images/elements/decore-right.png" class="decore-right" alt="Decore Right" width="175">
            <feather-icon icon="AwardIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
            <h1 class="mb-6 text-white">Congratulations {{first_name}},</h1>
            <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-white">You now in <b> {{packageDetails.name}} </b> package.
              <vx-tooltip id="v-step-0" :text="`Your package will expired on ${packageDetails.end_date}.`">
                <feather-icon class="cursor-pointer" icon="InfoIcon" svgClasses="h-4 w-4"/>
              </vx-tooltip>
            </p>
          </vx-card>
        </div>

        <!-- CARD 2: TOTAL FORM QUOTA -->
        <div id="v-step-1" class="vx-col w-full lg:w-1/3 mb-base justify-center">
          <a href="/forms" tabindex="-1" target="_self" aria-current="page">
          <vx-card slot="no-body" class="text-center">
              <feather-icon icon="FilePlusIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
              <h3 class="mb-6 text-black">Your QuickSend Form Summary</h3>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have total of:<strong> {{subscriptionSummary.total_form_quota}}</strong> forms.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have used of:<strong> {{subscriptionSummary.total_form_created}}</strong> forms.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">Now you left of:<strong> {{subscriptionSummary.total_form_quota - subscriptionSummary.total_form_created }}</strong> forms.</p>
          </vx-card>
          </a>
        </div>
        

        <!-- CARD 3: TOTAL USER QUOTA -->
        <div id="v-step-2" class="vx-col w-full lg:w-1/3 mb-base justify-center">
          <a href="/team" tabindex="-1" target="_self" aria-current="page">
          <vx-card slot="no-body" class="text-center">
              <feather-icon icon="BriefcaseIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
              <h3 class="mb-6 text-black">Your Sales Agent Summary</h3>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have total of:<strong> {{subscriptionSummary.total_user_quota}}</strong> agent.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have used of:<strong> {{subscriptionSummary.total_user_created}}</strong> agent.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">Now you left of:<strong> {{subscriptionSummary.total_user_quota - subscriptionSummary.total_user_created }}</strong> agent.</p>
          </vx-card>
          </a>
        </div>

          <!-- CARD 3: TOTAL PRODUCT QUOTA -->
        <div id="v-step-3" class="vx-col w-full lg:w-1/3 mb-base justify-center">
          <a href="/product" tabindex="-1" target="_self" aria-current="page">
          <vx-card slot="no-body" class="text-center">
              <feather-icon icon="PackageIcon" class="p-6 mb-8 bg-primary inline-flex rounded-full text-white shadow" svgClasses="h-8 w-8"></feather-icon>
              <h3 class="mb-6 text-black">Your Products Summary</h3>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have total of:<strong> {{subscriptionSummary.total_product_quota}}</strong> product.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">You have used of:<strong> {{subscriptionSummary.total_product_created}}</strong> product.</p>
              <p class="xl:w-3/4 lg:w-4/5 md:w-2/3 w-4/5 mx-auto text-black">Now you left of:<strong> {{subscriptionSummary.total_product_quota - subscriptionSummary.total_product_created }}</strong> product.</p>
          </vx-card>
          </a>
        </div>

      </div>
       <v-tour name="Tour" :steps="steps"></v-tour>
    </div>
  </div>
</template>

<script>
import StatisticsCardLine from '@/components/statistics-cards/StatisticsCardLine.vue'
import FeatherIcon from '../components/FeatherIcon.vue'
import router from '@/router'

const dialogs = {
  expired: (error) => {
    return {
      color: "primary", 
      title: "Your current package is expired!",
      text: "Subscribe a new pakcage to unlock the dashboard summary.",
      accept:() => {
        router.push('/billing/current-plan')
      },
      close:() => {
        router.push('/billing/current-plan')
      }
    }
  }
}

export default {
  data () {
    return {
      steps: [
          {
            target: '#v-step-0', 
            header: {
              title: 'Welcome to Quicksend!',
            },
            content: `Follow this guide and you’ll learn simple steps to create your order forms.`,
            params:{
              placement: 'bottom'
            }
          },
          {
            target: '#v-step-1', 
            header: {
              title: 'Order Forms',
            },
            content: `Create and share forms to customers and gain sales. Before that, publish some products first.`,
            params:{
              placement: 'bottom'
            }
          },
          {
            target: '#v-step-2', 
            header: {
              title: 'Set Up Your Team',
            },
            content: `Add your teammates to manage this store together. You can assign them as admins, sales or agents.`,
            params:{
              placement: 'bottom'
            }
          },
          {
            target: '#v-step-3', 
            header: {
              title: 'Products',
            },
            content: `Add your products and sell them through forms. Let’s click add a product now! Just click on the products summary box below.`,
            params:{
              placement: 'bottom'
            }
          },
      ]
    }
  },
  components: {
    StatisticsCardLine
  },
  created() {
    Promise.all(
      [
        this.$store.dispatch('subscription/getSubscriptionSummary'),
        this.$store.dispatch('subscription/getPackageDetails')
      ]
    )
    if(this.$store.state.user.organizations.find(o => o.organization_id === this.$store.state.user.current_organization).subscription === null){
       this.$vs.dialog(dialogs.expired())
    }
  },
  mounted(){
    this.$tours['Tour'].start()
  },
  computed: {
    first_name() {
      return this.$store.state.user.details.first_name
    },
    packageDetails() {
      return this.$store.state.subscription.package_summary
    },
    subscriptionSummary() {
      return this.$store.state.subscription.subscription_summary
    },
  },
  methods: {
  }
}
</script>

<style lang="scss">
strong {
  color: #f9278e;
}
/*! rtl:begin:ignore */
#dashboard-analytics {
  .greet-user{
    position: relative;

    .decore-left{
      position: absolute;
      left:0;
      top: 0;
    }
    .decore-right{
      position: absolute;
      right:0;
      top: 0;
    }
  }

  .v-tour {
    .v-step {
        // z-index: 55000;
        background-color: rgba(var(--vs-primary),1);
        border-radius: .5rem;
        padding: 1.5rem;
        filter: drop-shadow(0 0 7px rgba(0,0,0,.5));

        .v-step__arrow {
            border-color: rgba(var(--vs-primary),1);
        }

        .vs-button-border:not(.btn-tour-next):not(.btn-tour-finish) {
            border-color: rgba(255, 255, 255, .5) !important;
        }

        .v-step__header{
          background-color: #CE0668;
        }
    }
  }

  @media(max-width: 576px) {
    .decore-left, .decore-right{
      width: 140px;
    }
  }
}
/*! rtl:end:ignore */
</style>
